import { createFileRoute } from "@tanstack/react-router";
import SaintTmsTravel from "@/pages/SaintTmsTravel";
import {
  CLINIC_REF,
  buildBreadcrumbList,
  buildMedicalWebPage,
  SITE_URL,
} from "@/components/schemaConstants";
import { buildHreflang } from "@/lib/i18n/locale";

const TRAVEL_URL = `${SITE_URL}/saint-tms-travel`;
const BREADCRUMB_ID = `${TRAVEL_URL}#breadcrumb`;

export const Route = createFileRoute("/saint-tms-travel")({
  head: () => ({
    meta: [
      {
        title: "Travel to Coral Springs for SAINT® TMS | Neuro Wellness",
      },
      {
        name: "description",
        content:
          "Coming to Coral Springs, FL for SAINT® TMS: why a 5-day protocol makes travel practical, the treatment-week schedule, airports, lodging, and bringing a.",
      },
      {
        property: "og:title",
        content: "Travel to Coral Springs for SAINT® TMS",
      },
      {
        property: "og:description",
        content:
          "Why a 5-day SAINT® protocol makes travel practical — schedule, airports, lodging, and bringing a support person.",
      },
      {
        property: "og:url",
        content: TRAVEL_URL,
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [
      { rel: "canonical", href: TRAVEL_URL },
      ...buildHreflang("/saint-tms-travel"),
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          buildMedicalWebPage({
            name: "Travel to Coral Springs for SAINT® TMS",
            description:
              "Why a 5-day SAINT® TMS protocol makes travel practical for out-of-state patients — schedule, airports, lodging, and bringing a support person.",
            url: TRAVEL_URL,
            id: `${TRAVEL_URL}#webpage`,
            breadcrumbId: BREADCRUMB_ID,
          }),
        ),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify(
          buildBreadcrumbList(
            [
              { name: "Home", href: "/" },
              { name: "SAINT® TMS", href: "/saint" },
              {
                name: "Traveling for SAINT® TMS",
                href: "/saint-tms-travel",
              },
            ],
            BREADCRUMB_ID,
          ),
        ),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "MedicalTherapy",
          "@id": `${SITE_URL}/saint#therapy`,
          name: "SAINT® Accelerated TMS",
          description:
            "FDA-cleared, fMRI-guided 5-day accelerated transcranial magnetic stimulation for adults with major depressive disorder who have not achieved adequate relief from antidepressants.",
          url: `${SITE_URL}/saint`,
          provider: CLINIC_REF,
        }),
      },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <SaintTmsTravel />;
}
